import MediaPushLimitReachedModalComponent from "./MediaPushLimitReachedModalComponent";

export default MediaPushLimitReachedModalComponent;
